import { MatchPlayersSettings } from '@okletsplay/core';

export const MATCH_PLAYERS_DEFAULT_SETTINGS: MatchPlayersSettings = {
  minPlayersCount: 2,
  maxPlayersCount: 2,
};
